/** @param {string} tag
 *  @param {Record<string, string|boolean|null|undefined>} [attrs]
 *  @param {(Node|string|null|undefined)[]} [children]
 *  @returns {HTMLElement} */
export function el(tag, attrs = {}, ...children) {
  const node = document.createElement(tag)
  for (const [key, value] of Object.entries(attrs || {})) {
    if (value == null || value === false) continue
    if (key === "className" || key === "class") {
      node.className = String(value)
      continue
    }
    if (key === "dataset" && typeof value === "object") {
      for (const [dk, dv] of Object.entries(value)) {
        if (dv != null) node.dataset[dk] = String(dv)
      }
      continue
    }
    if (key === "text") {
      node.textContent = String(value)
      continue
    }
    if (key.startsWith("on") && typeof value === "function") {
      node.addEventListener(key.slice(2).toLowerCase(), value)
      continue
    }
    if (value === true) {
      node.setAttribute(key, "")
      continue
    }
    node.setAttribute(key, String(value))
  }
  for (const child of children.flat()) {
    if (child == null || child === false) continue
    node.append(typeof child === "string" ? document.createTextNode(child) : child)
  }
  return node
}

export function clear(node) {
  while (node.firstChild) node.removeChild(node.firstChild)
}

export function stringify(value) {
  if (value == null) return ""
  if (typeof value === "string") return value
  if (typeof value === "number" || typeof value === "boolean") return String(value)
  return ""
}

export function firstNonEmpty(...values) {
  for (const v of values) {
    const s = typeof v === "string" ? v.trim() : stringify(v)
    if (s) return typeof v === "string" ? v : s
  }
  return ""
}

export function normalizeMark(value) {
  const s = stringify(value)
  if (s === "+" || s === "＋") return "+"
  if (s === "-" || s === "−" || s === "–") return "−"
  return ""
}

export function joinFactors(factors) {
  return (factors || []).filter(Boolean).join(", ")
}

export function rawFallback(data) {
  try {
    return el("pre", { className: "raw-json" }, JSON.stringify(data ?? {}, null, 2))
  } catch {
    return el("pre", { className: "raw-json" }, String(data ?? ""))
  }
}
